import { useState } from 'react';
import classNames from 'classnames';
import axios from 'axios';
import { InputNew, TextareaNew, Button } from '../../../ui';
import OfferModal from './OfferModal';

const packageOptions = ['CTV ստարտ', 'CTV հիմնական', 'CTV ինտենսիվ'];

const OfferForm = () => {
  const [values, setValues] = useState({
    fullName: '',
    companyName: '',
    email: '',
    goal: '',
    package: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isThanksOpen, setIsThanksOpen] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!values.fullName) newErrors.fullName = 'Պարտադիր դաշտ';
    if (!values.companyName) newErrors.companyName = 'Պարտադիր դաշտ';
    if (!values.email) newErrors.email = 'Պարտադիր դաշտ';
    if (!values.package) newErrors.package = 'Պարտադիր դաշտ';
    return newErrors;
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: '' });
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    const formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    formData.append('service', `CTV Package Request from ${values.companyName}`);

    axios.post('https://mailer.weprodigi.com/api/v1/smart-tv-advertising', formData).then(() => {
      setLoading(false);
      setIsThanksOpen(true);
      setValues({ fullName: '', companyName: '', email: '', goal: '', package: '', message: '' });
    });
  };

  return (
    <div className="relative">
      <form onSubmit={handleSubmit} className="flex flex-col gap-[16px]">
        <InputNew
          label="Անուն Ազգանուն"
          isRequired
          name="fullName"
          placeholder="Անուն Ազգանուն"
          value={values.fullName}
          error={errors.fullName}
          onChange={handleChange}
        />
        <div className="flex md:flex-row flex-col gap-[16px]">
          <div className="w-full md:w-1/2">
            <InputNew
              label="Ընկերության անվանում"
              isRequired
              name="companyName"
              placeholder="Ընկերության անվանում"
              value={values.companyName}
              error={errors.companyName}
              onChange={handleChange}
            />
          </div>
          <div className="w-full md:w-1/2">
            <InputNew
              label="Աշխատանքային էլ. հասցե"
              isRequired
              name="email"
              type="email"
              placeholder="Աշխատանքային էլ. հասցե"
              value={values.email}
              error={errors.email}
              onChange={handleChange}
            />
          </div>
        </div>
        <InputNew
          label="Գովազդային արշավի նպատակ"
          name="goal"
          placeholder="Գովազդային արշավի նպատակ"
          value={values.goal}
          error={errors.goal}
          onChange={handleChange}
        />
        <div className="flex flex-col gap-[6px]">
          <select
            name="package"
            value={values.package}
            onChange={handleChange}
            className={classNames(
              'appearance-none bg-white w-full rounded-[10px] text-[16px] pl-[24px] pr-[48px] py-[16px] text-[#000000] focus:outline-none bg-no-repeat',
              errors.package && '!bg-[#FFD5D6]'
            )}
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='8' viewBox='0 0 14 8' fill='none'%3E%3Cpath d='M1.51 0.077 0.333 1.257 7 7.924l6.667-6.667L12.487.077 7 5.564 1.51.077Z' fill='%23000'/%3E%3C/svg%3E\")",
              backgroundPosition: 'right 20px center',
            }}
          >
            <option value="">Ընտրեք փաթեթը</option>
            {packageOptions.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {errors.package && <span className="text-[#ED1C24] animate-warning text-[12px] ml-[20px]">{errors.package}</span>}
        </div>
        <div className="flex flex-col gap-[16px] w-full">
          <p className="text-[16px] md:text-[18px] font-normal text-white">Լրացուցիչ տեղեկություն</p>
          <TextareaNew name="message" placeholder="Լրացուցիչ տեղեկություն" value={values.message} onChange={handleChange} />
        </div>
        <Button type="submit" variant="blackOffer" className="w-full">
          {loading ? 'Ուղարկվում է...' : 'Ստանալ CTV առաջարկ'}
        </Button>
      </form>
      {isThanksOpen && <OfferModal />}
    </div>
  );
};

export default OfferForm;
